var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-card", {
    staticClass: "card-activity",
    attrs: {
      error: _vm.error,
      isCustomizable: _vm.settings.isCustomizable,
      type: _vm.settings.context,
      loading: _vm.loading
    },
    on: {
      "hide-card": function($event) {
        return _vm.$emit("hide-card", "activity")
      },
      "refresh-card": function($event) {
        return _vm.fetchCard("activity", {}, true)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _vm.cardData && _vm.cardData.length > 0
              ? _c(
                  "ul",
                  _vm._l(_vm.cardData, function(staff) {
                    return _c(
                      "li",
                      { key: staff.userid, staticClass: "activity" },
                      [
                        _c("a", { attrs: { href: "/staff/" + staff.userid } }, [
                          _c("p", [
                            _c("span", {
                              staticClass: "chip",
                              class: _vm.isActive(staff.lastActivity)
                            }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(staff.forename) +
                                " " +
                                _vm._s(staff.name) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "details" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$l10n.__("Dernière activité :")) +
                                  "\n                            " +
                                  _vm._s(
                                    _vm.$filters.dateFormatter(
                                      staff.lastActivity,
                                      "NORMAL_DATE_TIME",
                                      false
                                    )
                                  )
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }